const NEXT_API_ENDPOINT='https://api3bkkc76.execute-api.eu-west-1.amazonaws.com/prod'

// https://3mfe4yt7xd.execute-api.eu-west-1.amazonaws.com/dev/api/searchOrder?searchField=order_number&searchVal=11509334432

export const baseEndpoint = `${NEXT_API_ENDPOINT}/api`;

// DRN search
export const drnEndpoint = `${baseEndpoint}/searchOrder`;

// Regions load
export const regionEndpoint = `${baseEndpoint}/getRegion`;

// get-drn-search-filter-dropdown
export const drnSearchFilterDropdown = `${baseEndpoint}/drn-get-search-filter`;
// Region Search
export const regionSearch = `${baseEndpoint}/searchByRegion`

// upload DRN
export const uploadDrn = `${baseEndpoint}/uploadDrnData`;

// upload search
export const uploadSearch = `${baseEndpoint}/getOrderDetails`

// download Documents
export const downloadDocuments = `${baseEndpoint}/downloadInvoice`

// download all Documents
export const downloadALLDocuments = `${baseEndpoint}/downloadAll`

// download all Tax Documents
export const downloadALLTaxDocuments = `${baseEndpoint}/drn-tax-downloadAll`

//authorization
export const authorization = `${baseEndpoint}/getRole`;

// delete Documents
export const deleteDocuments = `${baseEndpoint}/deleteDocument`;

//Preview Document
export const previewDocument = `${baseEndpoint}/previewDocument`
// Questionnaire orders info
export const questionnaireOrders = `${baseEndpoint}/drn-fetch-itr-details`
// Questionnaire fetch questions
export const questionnaireFetch = `${baseEndpoint}/drn-fetchQuestionnaireBySearch`
// Questionnaire save answers
export const questionnaireSave = `${baseEndpoint}/update_itr_responce`
//get tax certificate 
export const getTaxCertificate = `${baseEndpoint}/drn-get-tax` 
//get filer details for tax certificate
export const getTaxFilerDetails = `${baseEndpoint}/drn-get-tax-filter`
//get tax notifications
export const getTaxNotifications = `${baseEndpoint}/drn-get-tax-notifications`
//tax update
export const updateTax = `${baseEndpoint}/drn-tax-update`
// export anual certificate search
export const annualCertificateSearch = `${baseEndpoint}/drn-ac-fetch`
//export anual certificate validation
export const annualCertificateValidation = `${baseEndpoint}/drn-ac-update`
//export anual certificate upload
export const annualCertificateUpload = `${baseEndpoint}/drn-ac-upload`
